<template>
  <div>
    <van-popup
      v-model="isShowPopup"
      position="bottom"
      :style="{ height: '100%' }"
    >
      <div class="sm-container">
        <div class="sm-poster" ref="poster">
          <img
            class="sm-poster-bg"
            src="https://p0.meituan.net/wxapp/124686bafaf92e741e928c7703088025213851.png"
          />
          <img
            class="sm-poster-qrcode"
            src="https://p1.meituan.net/wxapp/48579492fa47990c780d82ee65824cbf38306.png"
          />
          <div
            class="sm-poster-bank"
          >
            <div
              class="sm-poster-bank-logo"
            >
              <img
                class="sm-poster-bank-logo-img"
                :src="lotteryBank.bankIcon"
              />
            </div>
            <div
              class="sm-poster-bank-name"
            >
              {{ lotteryBank.bankName }}
            </div>
            <div
              class="sm-poster-bank-tip"
            >祝你</div>
          </div>
          <div
            class="sm-poster-title"
          >
            {{ accessoryInfo.greetings }}
          </div>
          <div
            class="sm-poster-content"
          >
            <img
              class="sm-poster-content-bg"
              src="https://p0.meituan.net/wxapp/fc700e46fcd72d8263e37f2b4b86d8a18941.png"
            />
            <div
              class="sm-poster-content-accessory"
            >
              <div
                class="sm-poster-content-accessory-show"
              >
                <img
                  class="sm-poster-content-show-pic-portrait"
                  :src="portraitBase64"
                />
                <img
                  class="sm-poster-content-show-pic"
                  :src="accessoryInfo.rewardPicture.static"
                />
              </div>
              <div
                class="sm-poster-content-info"
              >{{ accessoryInfo.rewardName }}</div>
            </div>
            <div
              class="sm-poster-content-award"
            >
              <div
                class="sm-poster-content-award-show"
              >
                <img
                  class="sm-poster-content-show-pic"
                  :src="awardInfo.rewardPicture.static"
                />
              </div>
              <div
                class="sm-poster-content-info"
              >{{ awardInfo.rewardName }}</div>
            </div>
          </div>
          <div ref="canvasContainer" v-show="false">
          </div>
        </div>
        <div class="sm-share">
          <div
            class="sm-share-list"
          >
            <div
              class="sm-share-item"
              v-for="(share, index) in shareList"
              :key="index"
              @click="onShare(share.channel, share.name)"
            >
              <div
                class="sm-share-item-icon"
                :style="{ backgroundImage: 'url(' + share.icon + ')' }"
              ></div>
              <div>{{ share.name }}</div>
            </div>
          </div>
          <div
            class="sm-share-cancel"
            @click="closeModal"
          >取消</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import { Popup, Toast } from 'vant';
import { monitor } from '@/common/monitor';
import { api } from '@/common/api';
import html2canvas from 'html2canvas';
import { shareImage } from '@/tools/shareUtils';
import { lx } from '@/analytic/index';
import { lxConfig } from '@/analytic/profilePhoto';
import { lotteryActivityId } from '@/common/config';
import { env } from '@/common/env';
import { bankInfo } from '../../config/bankInfo';

Vue.use(Popup);
Vue.use(Toast);

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hctUserRewardInfoBOS: {
      type: Array,
      default: () => []
    },
    portraitStatus: {
      type: Boolean,
      default: false
    },
    appPortrait: {
      type: String,
      default: ''
    },
    lotteryCount: {
      type: String,
      default: ''
    },
    cityId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isShowPopup: this.visible,
      shareList: [{
        channel: 'WECHAT_FRIENDS',
        name: '微信好友',
        icon: 'https://p1.meituan.net/wxapp/5f19d2e72779ceb0eb6901bb9db073bf4049.png'
      }, {
        channel: 'WECHAT_TIMELINE',
        name: '朋友圈',
        icon: 'https://p0.meituan.net/wxapp/7c05a7bc0bfeb03e3942f91e61dcd5e74188.png'
      }],
      portraitBase64: ''
    };
  },
  mounted() {
    // let url = 'https://www.cashyuan.com.cn:9003/avatar07/avatar/d156968c9f96437f9424fc89538fd83b.png';
    // let url = 'https://mds.cashyuan.com:9004/avatar07/avatar/002926bd2e4546e28b14e5c938cfb0d8.png';
    let url = 'https://p0.meituan.net/wxapp/c6a436105a62d7a8029cbd46609f13c44783.png';
    if (this.portraitStatus) {
      url = `${this.appPortrait}?time=${new Date().getTime()}`;
    }
    console.log('base64初始化', this.appPortrait, this.portraitStatus, url);
    let base64 = '';
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = url;
    img.onerror = () => {
      monitor.captureMessage({
        name: '【好彩头-图片下载失败】',
        msg: url
      }, {
        level: 'warn'
      });
    };
    img.onload = () => {
      base64 = this.image2Base64(img);
      this.portraitBase64 = base64;
    };
  },
  watch: {
    visible(newValue, oldValue) {
      this.isShowPopup = newValue;
      if (newValue) {
        lx.mv(lxConfig.share_modal_mv, {
          activity_id: env.actGroupName || lotteryActivityId,
          bank_id: this.lotteryBank.bankId,
          status: this.lotteryCount,
          city_id: this.cityId
        }, {
          cid: lxConfig.index_pv
        });
      }
    },
    isShowPopup(newValue, oldValue) {
      if (!newValue) {
        this.$emit('update:visible', false);
        this.$emit('onClose');
      }
    },
    portraitStatus(newValue, oldValue) {
      console.log('头像变化', newValue, oldValue);
      // let url = 'https://www.cashyuan.com.cn:9003/avatar07/avatar/d156968c9f96437f9424fc89538fd83b.png';
      // let url = 'https://mds.cashyuan.com:9004/avatar07/avatar/002926bd2e4546e28b14e5c938cfb0d8.png';
      let url = 'https://p0.meituan.net/wxapp/c6a436105a62d7a8029cbd46609f13c44783.png';
      if (newValue) {
        url = `${this.appPortrait}?time=${new Date().getTime()}`;
      }
      console.log('头像变化-url', url);
      let base64 = '';
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.src = url;
      img.onerror = () => {
        monitor.captureMessage({
          name: '【好彩头-图片下载失败】',
          msg: url
        }, {
          level: 'warn'
        });
      };
      img.onload = () => {
        base64 = this.image2Base64(img);
        this.portraitBase64 = base64;
      };
    },
    appPortrait(newValue, oldValue) {
      console.log('变更头像', newValue, oldValue);
      if (this.portraitStatus && newValue) {
        const url = `${newValue}?time=${new Date().getTime()}`;
        let base64 = '';
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = url;
        img.onerror = () => {
          monitor.captureMessage({
            name: '【好彩头-图片下载失败】',
            msg: url
          }, {
            level: 'warn'
          });
        };
        img.onload = () => {
          base64 = this.image2Base64(img);
          this.portraitBase64 = base64;
        };
      }
    }
  },
  computed: {
    lotteryBank() {
      const lottery = (this.hctUserRewardInfoBOS && this.hctUserRewardInfoBOS[this.hctUserRewardInfoBOS.length - 1]) || {};
      if (!lottery.bankTypeId) {
        return {};
      }
      const bank = bankInfo[lottery.bankTypeId];
      return bank;
    },
    accessoryInfo() {
      const accessory = this.parseAccessory(true);
      const pictureJson = (accessory && accessory.rewardPicture) || '';
      const pictureObj = this.parsePictureJson(pictureJson);
      accessory.rewardPicture = pictureObj;
      return accessory;
    },
    awardInfo() {
      const award = this.parseAccessory(false);
      const pictureJson = (award && award.rewardPicture) || '';
      const pictureObj = this.parsePictureJson(pictureJson);
      award.rewardPicture = pictureObj;
      return award;
    }
  },
  methods: {
    image2Base64(img) {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, img.width, img.height);
      const dataUrl = canvas.toDataURL('image/png');
      return dataUrl;
    },
    closeModal() {
      this.isShowPopup = false;
    },
    parseAccessory(isAccessory) {
      const lottery = (this.hctUserRewardInfoBOS && this.hctUserRewardInfoBOS[this.hctUserRewardInfoBOS.length - 1]) || {};
      if (!lottery.singleRewardInfos) {
        return {};
      }
      const singleRewardInfos = lottery.singleRewardInfos || [];
      let item = null;
      if (isAccessory) {
        item = singleRewardInfos.find((s) => s.rewardType === 'ACCESSORY');
      } else {
        item = singleRewardInfos.find((s) => {
          if (singleRewardInfos.length > 2) {
            // 返回三个权益时，不展示红包(邮储会有红包+券包+挂件的场景)
            return (s.rewardType !== 'ACCESSORY') && (s.rewardType !== 'REDPCT');
          } else {
            return s.rewardType !== 'ACCESSORY';
          }
        });
      }
      if (!item) {
        return {};
      }
      return item;
    },
    parsePictureJson(jsonStr) {
      if (!jsonStr) {
        return {
          static: '',
          dynamic: ''
        };
      }
      if (typeof (jsonStr) === 'string') {
        const json = JSON.parse(jsonStr);
        return json;
      }
      return jsonStr;
    },
    onShare(channel, name) {
      lx.mc(lxConfig.share_modal_btn_mc, {
        activity_id: env.actGroupName || lotteryActivityId,
        bank_id: this.lotteryBank.bankId,
        status: this.lotteryCount,
        button_name: name,
        city_id: this.cityId
      }, {
        cid: lxConfig.index_pv
      });
      Toast.loading({
        duration: 0,
        forbidClick: true,
        message: '处理中...'
      });
      api.shareHctActivity();
      if (channel === 'WECHAT_FRIENDS' || channel === 'WECHAT_TIMELINE') {
        this.genImage().then((res) => {
          Toast.clear();
          shareImage(KNB.shareImage[channel], () => {
            // api.shareHctActivity();
          });
          this.closeModal();
        }).catch((err) => {
          Toast.clear();
          monitor.captureMessage({
            name: '【好彩头-分享海报失败】',
            msg: JSON.stringify(err)
          }, {
            level: 'warn'
          });
        });
      }
    },
    genImage() {
      const preCanvas = document.getElementById('canvas');
      if (preCanvas) {
        this.$refs.canvasContainer.removeChild(preCanvas);
      }
      const $image = this.$refs.poster;
      const width = $image.offsetWidth;
      const height = $image.offsetHeight;
      const canvas = document.createElement('canvas');
      canvas.id = 'canvas';
      const scale = window.devicePixelRatio || 1;
      canvas.width = width * scale;
      canvas.height = height * scale;
      canvas.getContext('2d').scale(scale, scale);
      const opts = {
        canvas,
        scale,
        width,
        height,
        useCORS: true
      };
      return new Promise((resolve, reject) => {
        html2canvas($image, opts).then((_canvas) => {
          const context = _canvas.getContext('2d');
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          context.imageSmoothingQuality = 'high';
          this.$refs.canvasContainer.appendChild(_canvas);
          resolve();
        }).catch((err) => { reject(err); });
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '../../../../styles/base.less';
@import '../../../../styles/fn.less';
.sm-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.sm-poster {
  .size(6.5rem, 10.04rem);
  margin: 1.8rem auto 0 auto;
  padding-top: 2.96rem;
  position: relative;
  box-sizing: border-box;
  border-radius: .3rem;
  &-bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
  }
  &-qrcode {
    position: absolute;
    width: 1.2rem;
    height: 1.2rem;
    bottom: 0.31rem;
    right: 0.79rem;
  }
  &-bank {
    height: .3rem;
    display: flex;
    justify-content: center;
    &-logo {
      .size(.25rem, .25rem);
      position: relative;
      margin-top: 0.025rem;
      &-img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
    &-name {
      font-family: PingFangSC-Medium;
      font-size: .22rem;
      color: #FEFDE5;
      font-weight: 500;
      height: .3rem;
      line-height: .3rem;
      margin: 0 .06rem;
    }
    &-tip {
      font-family: PingFangSC-Regular;
      font-size: .2rem;
      color: #FEFDE5;
      font-weight: 400;
      height: .3rem;
      line-height: .3rem;
    }
  }
  &-title {
    font-family: 'MF-YuanHeiNoncommercial-Regular';
    font-size: .48rem;
    height: .48rem;
    line-height: .48rem;
    margin: .2rem auto .25rem auto;
    text-align: center;
    color: #f9efde;
    position: relative;
  }
  &-content {
    .size(4.69rem, 2.93rem);
    margin: 0 auto .2rem auto;
    display: flex;
    justify-content: space-between;
    padding: 0 .35rem 0 .22rem;
    position: relative;
    &-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
    }
    &-accessory {
      width: 1.95rem;
      margin-top: .32rem;
      &-show {
        .size(1.6rem, 1.6rem);
        position: relative;
        margin-left: 0.175rem;
        position: relative;
      }
    }
    &-award {
      width: 1.95rem;
      margin-top: .45rem;
      &-show {
        .size(1.4rem, 1.4rem);
        position: relative;
        margin: 0 0.275rem .12rem 0.275rem;
        position: relative;
      }
    }
    &-show-pic {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }
    &-show-pic-portrait {
      .size(1.2rem, 1.2rem);
      position: absolute;
      left: 0.2rem;
      top: 0.2rem;
    }
    &-info {
      width: 1.95rem;
      font-family: PingFangSC-Regular;
      font-size: .23rem;
      color: #811500;
      text-align: center;
      line-height: 30px;
      font-weight: 400;
      margin-top: .07rem;
    }
  }
}
.sm-share {
  position: absolute;
  width: 100%;
  height: 3.56rem;
  bottom: 0;
  background: #fff;
  border-radius: 20px 20px 0 0;
  &-list {
    height: 2rem;
    display: flex;
    justify-content: left;
    padding-top: .3rem;
  }
  &-item {
    width: 25vw;
    text-align: center;
    &-icon {
      .size(1rem, 1rem);
      margin: 0 auto .05rem auto;
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  &-cancel {
    height: 1.55rem;
    line-height: 1.55rem;
    border-top: 1px solid #A5B7CA;
    text-align: center;
  }
}
.van-popup {
  background-color: transparent;
}
/deep/ .van-overlay {
  background-color: rgba(0,0,0,.85) !important;
}
</style>
